import { render, staticRenderFns } from "./MyEditor.vue?vue&type=template&id=51b2bc80&"
import script from "./MyEditor.vue?vue&type=script&lang=js&"
export * from "./MyEditor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports